import {AxiosResponse} from "axios";
import * as React from "react";
import {HttpError} from "../../../common/components/shared/httpError/httpError";
import {Popup} from "../../../common/components/shared/popup/popup";
import TextInput from "../../../common/components/shared/textInput/textInput";
import {HttpErrorModel} from "../../../common/models/httpError";
import {Api} from "../../../helpers/api";
import {ValidatedValue} from "../../../helpers/validatedValue";
import i18n from "../../../i18n/i18n";
import {ReactComponent as ScanBarcodeIcon} from "../../../statics/icons/icon_scanBarcode.svg";
import "./scanBarcodePopup.scss";

interface ScanBarcodePopupProps {
    barcodeNo: ValidatedValue<string>;
    displayPopup: boolean;
    confirm: () => void;
    closePopup: () => void;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    isPopupActionWaiting: boolean;
}

export default function ScanBarcodePopup(props: ScanBarcodePopupProps): React.ReactElement {
    const content = (
        <>
            <div className="scan-barcode-content">
                <ScanBarcodeIcon />
                <p>{i18n.t("transportation.ticket.scanBarcodePopup.content")}</p>
            </div>
            <TextInput
                label={i18n.t("transportation.ticket.scanBarcodePopup.label")}
                validatedValue={props.barcodeNo}
                testId={"scan-barcode-popup-input"}
                isAutoFocus
            />
        </>
    );

    return (
        <Popup
            open={props.displayPopup}
            className="scan-barcode-popup"
            header={i18n.t("transportation.ticket.scanBarcodePopup.header")}
            content={content}
            actionText={i18n.t("transportation.ticket.scanBarcodePopup.actionText")}
            action={props.confirm}
            cancel={props.closePopup}
            testId="scan-barcode-popup"
            httpError={(
                <>
                    {!Api.isSuccess(props.response) && (
                        <HttpError
                            response={props.response}
                            cause={i18n.t("transportation.ticket.scanBarcodePopup.errorMessage")}
                        />
                    )}
                </>
            )}
            isWaiting={props.isPopupActionWaiting}
        />
    );
}